import { Icon24AddOutline, Icon24LockOutline } from '@vkontakte/icons';
import previewDarkImage from 'img/familyPreview/dark_v2.png';
import previewLightImage from 'img/familyPreview/light_v2.png';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { familyFeaturePreviewProduct } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './FamilyPreviewPage.css';

const createAlbumText = 'Создать семейный\nальбом';
const createFolderText = 'Создать семейную\nпапку';

// eslint-disable-next-line react/display-name
const CreateButtonComponent: React.FC<{ type: FamilyContentCategoryType }> = memo(({ type }) => {
    const text = type === FamilyContentCategoryType.folders ? createFolderText : createAlbumText;

    return (
        <div className={styles.button} data-qa-id="create-button-component">
            <div className={styles.lockIcon} data-qa-id="create-button-component-lock-icon">
                <Icon24LockOutline width={20} height={20} />
            </div>
            <div className={styles.addIcon} data-qa-id="create-button-component-add-icon">
                <Icon24AddOutline width={20} height={20} />
            </div>
            <div className={styles.text} data-qa-id="create-button-component-text">
                {text}
            </div>
        </div>
    );
});

// eslint-disable-next-line react/display-name
export const FamilyPreviewPage: React.FC<{ type: FamilyContentCategoryType; paySource: string }> = memo(({ type, paySource }) => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const dispatch = useDispatch();

    useEffect(() => {
        sendPaymentGa({ eventCategory: `promo_empty_state_family_${type}`, action: 'show' });
    }, []);

    const onFastCheckoutClick = useCallback(async () => {
        sendPaymentGa({ eventCategory: `promo_empty_state_family_${type}`, action: 'click' });
        await productsController.loadProducts();
        dispatch(
            openTariffBuy({
                productId: familyFeaturePreviewProduct,
                paySource,
                onSuccess: () => {
                    sendPaymentGa({ eventCategory: `family-tariff`, action: 'buy', source: familyFeaturePreviewProduct });
                },
            })
        );
    }, [dispatch]);

    return (
        <div className={styles.root} data-qa-id="family-preview">
            <CreateButtonComponent type={type} />
            <img
                src={isDarkTheme ? previewDarkImage : previewLightImage}
                alt="Общие дела"
                className={styles.image}
                onClick={onFastCheckoutClick}
                data-qa-id="family-preview-image"
            />
        </div>
    );
});
